import {TextInput} from "@/components/inputs";
import Link from "next/link";
import {GoogleLogo} from "@/components/logo";
import {useState} from "react";
import {fetchData} from "@/utils/global-functions";
import {APP_NAME, REQ_TYPES} from "@/constants/general-constants";
import {toast} from "react-toastify";
import {useRouter} from "next/router";
import Cookies from "js-cookie";
import {login} from "@/redux/slices/user-slice";
import {useDispatch} from "react-redux";
import {useGoogleLogin} from "@react-oauth/google";
import {DesktopSize} from "@/components/responsive";
import {MobileBottomSheet, MobileBottomSheetHeader, SimpleModal} from "@/components/modal";

export default function LoginForm({onNext, prevMobile = "", userType}) {

    const [mobile, setMobile] = useState(prevMobile);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const router = useRouter();

    const signIn = useGoogleLogin({
        onSuccess: tokenResponse => onSuccessLogin(tokenResponse),
        onError: (errorResponse) => toast.error("احرازهویت با جیمیل موفقیت آمیز نبود")
    });

    const onSuccessLogin = async (tokenResponse) => {

        const loginData = await fetchData("auth/google", REQ_TYPES.POST, {user_type: userType}, tokenResponse?.access_token)

        if (!loginData.error) {
            toast.success("خوش آمدید!");

            Cookies.set(process.env.NEXT_PUBLIC_FREELANCER_TOK, loginData.data.data.token, {
                expires: 31,
                domain: `.${process.env.NEXT_PUBLIC_MAIN_URL}`
            });
            dispatch(login());

            if (router.query.url) {
                await router.replace(router.query.url);
            } else {
                await window.location.replace(`${userType === 1 ? process.env.NEXT_PUBLIC_FREELANCER_URL : process.env.NEXT_PUBLIC_EMPLOYER_URL}`);
            }
        }
    }

    const changeHandler = ({target: {value}}) => {
        setMobile(value)
    }

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!mobile || mobile.length !== 11) {
            toast.error("شماره تلفن نامعتبر")
            return false;
        }

        const data = await fetchData("auth/check", REQ_TYPES.POST, {mobile});
        if (!data.error) {
            toast.success("کد تایید ارسال شد!")
            onNext({
                ...data.data.data,
                mobile
            });
        }
    }

    const onClose = () => {
        setOpen(false)
    }

    return (
        <>
            <div className="text-center">
                <h2 className="font-bold text-xl">ورود یا ثبت‌نام</h2>

                <form className="mt-[3.125rem] sm:px-[2.375rem]" onSubmit={submitHandler}>
                    <TextInput
                        label="شماره همراه خود را وارد کنید"
                        placeholder="09120000000"
                        name="mobile"
                        type="tel"
                        pattern="[0]{1}[0-9]{10}"
                        value={mobile}
                        onChange={changeHandler}
                        classes={{
                            labelClasses: "mr-0 text-pol-dark-800 mb-4",
                            inputClasses: "bg-pol-light-7 text-center"
                        }}/>
                    <button
                        type="submit"
                        className="btn-dark w-full font-semibold text-sm py-[0.815rem] mt-[1.125rem]">
                        ثبت و ادامه
                    </button>
                </form>
                <p className="text-sm mt-6 text-pol-gray-600">
                    ورود و ‌ثبت‌نام شما به معنای پذیرش
                    <Link href="/privacy" className="text-pol-blue"> قوانین </Link>
                    {APP_NAME} است.
                </p>
                <span className="block w-full bg-pol-blue-light h-px mt-[3.125rem]"/>

                <div className="sm:px-[2.375rem] mt-7 text-sm text-pol-dark-800">
                    <button onClick={() => setOpen(true)}>روشهای دیگر</button>
                </div>
            </div>

            {/* Modal */}
            <DesktopSize>
                <SimpleModal
                    open={open}
                    onCloseModal={onClose}
                >
                    <div className="w-9/12 mx-auto min-h-[20rem] rounded-[2.5rem] flex overflow-hidden">
                        <div className="flex-grow pt-[2.875rem] pb-9 px-10">
                            <div className="flex justify-center">
                                <i className="icon-password text-3xl"></i>
                            </div>
                            <h2 className="text-center text-pol-dark text-lg font-bold mt-3.5">روشهای ورود </h2>

                            <button
                                onClick={() => signIn()}
                                className="flex items-center justify-center py-2.5 border border-pol-gray-light-5 w-full rounded-[0.813rem] text-sm text-pol-dark-800 mt-10">
                                <GoogleLogo/>
                                <span className="mr-2.5">ورود با گوگل</span>
                            </button>
                        </div>
                    </div>
                </SimpleModal>
            </DesktopSize>

            <MobileBottomSheet
                otherClassName="content-pol-light-purple-14"
                onDismiss={onClose}
                defaultSnap={({maxHeight}) => [maxHeight * 0.4]}
                snapPoints={({maxHeight}) => [maxHeight * 0.4]}
                open={open}
                header={
                    <MobileBottomSheetHeader
                        onDismiss={onClose}
                        title="روشهای ورود"/>
                }
            >
                <div className="container mt-6 pb-10">
                    <div className="mobile-content-p">

                        <button
                            onClick={() => signIn()}
                            className="flex items-center justify-center py-2.5 border border-pol-gray-light-5 w-full rounded-[0.813rem] text-sm text-pol-dark-800">
                            <GoogleLogo/>
                            <span className="mr-2.5">ورود با گوگل</span>
                        </button>

                    </div>
                </div>
            </MobileBottomSheet>
        </>

    )
}
